<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/02e_Culto_Sant-Adriano_San-Demetrio-Corone.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Luoghi d’arte, storia e spiritualità</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a class="active">Luoghi d’arte, storia e spiritualità</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            La Calabria presenta un tessuto fittissimo di borghi, paesi e città, ben 404 “campanili” ciascuno dei quali racchiude storie, 
            tradizioni e lingue altrove introvabili. L’itinerario dei Musei storici e naturalistici offre tante tappe: luoghi in cui è possibile scoprire 
            l’universo produttivo della seta e dei tessuti, come a Longobucco, San Floro, Tiriolo; oppure entrare in contatto con il mondo dei metalli, nel 
            Museo delle Reali Ferriere di Mongiana, o con l’universo della civiltà contadina e artigiana a Cerchiara e Monterosso Calabro. Si può scoprire la 
            storia e la cultura delle comunità linguistiche ancora vive in Calabria, quella arbëreshe nel Museo etnico di Civita e quella grecanica nei Musei 
            di Bova Gallicianò. Si possono visitare Musei d’azienda che riguardano produzioni molto legate alla tradizione di questa terra, come quello della 
            Liquirizia “Giorgio Marelli” di Rossano, del Lanificio Leo di Soveria Mannelli, dove ha sede anche il Museo “Carta” dell’editore Rubbettino, e quello 
            della lavorazione del tonno del Gruppo Callipo, a Pizzo Calabro; ma anche Vi.te.s., lo spazio museale dell’azienda Librandi dedicato al vino a Cirò Marina. 
            E poi ancora il Museo esperienziale GIAS a Mongrassano che racconta la trasformazione dei prodotti agricoli della Valle del Crati, per finire con il Museo 
            del Bergamotto di Reggio Calabria.
            <br>
            <br>
            Tutte le città presentano Musei d’arte di particolare interesse, tra cui si segnalano la Galleria Nazionale di Cosenza, il Marca di Catanzaro, 
            la Pinacoteca Civica di Reggio Calabria, ma anche interessanti luoghi e allestimenti site specific dedicati all’arte contemporanea, come il Museo 
            all’aperto Bilotti di Cosenza e il Parco internazionale della scultura Catanzaro, le statue monumentali di Rabarama sul lungomare Falcomatà di Reggio 
            Calabria a cui fanno eco il Mabos Museo d’arte contemporanea nel Bosco della Sila e il Musaba di Mammola nel complesso monumentale di Santa Barbara.
            <br>
            <br>
            Tra gli altri itinerari molto affascinanti vi è quello dei castelli che connotano borghi e luoghi di raro fascino, tra cui emergono Rocca Imperiale, 
            Amendolara, la punta di Roseto Capo Spulico, Castrovillari, Corigliano Calabro, Belvedere Marittimo, Cosenza, Fiumefreddo Bruzio, Caccuri, Santa Severina, 
            Amantea, Crotone, Le Castella a Isola Capo Rizzuto, Catanzaro, Squillace, Pizzo Calabro, Vibo Valentia, Nicotera, Stilo, Palmi, Gerace, Scilla, Reggio Calabria.
            <br>
            <br>
            Infine, un capitolo a sé meritano gli itinerari della spiritualità che trovano nei Cammini la loro espressione più tangibile ed emozionante; 
            tra questi emergono il Cammino di San Francesco Da Paola, il Cammino Basiliano e quello di Gioacchino da Fiore. Ma tanti sono i luoghi di fede di 
            antica memoria, come la Cattolica di Stilo e la Certosa di Serra San Bruno, tra i più noti, ma anche il Convento di San Demetrio Corone, 
            l’abbazia di San Giovanni in Fiore e le rovine dei Conventi di Corazzo e Convento domenicano di Soriano Calabro, senza dimenticare il Duomo di Cosenza e 
            le Chiese di Morano Calabro, Altomonte, Gerace e i tanti Santuari extra moenia: Il Santuario di Santa Maria delle Armi di Cerchiara, 
            la Madonna del Pettoruto di San Sosti, l’Abbazia di Santa Maria della Matina di San Marco Argentano, il Santuario di San Francesco da Paola e 
            quello della Madonna di Porto di Gimigliano, Il Santuario della Madonna della Montagna di Polsi, oltre al Monastero della Visitazione di Santa Maria 
            da cui si domina la città di Reggio Calabria e lo Stretto.        
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>